import React, {useState, useEffect} from "react";
import PageWrapper from "../../../pagecomponents/Common/PageWrapper.js";
import ModalWrapper from "../../../pagecomponents/Common/ModalWrapper.js";
import DataTable from "../../../pagecomponents/Common/DataTable.js";
import LedgerAddEdit from "./AddEditForm.js";
import { ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { toastMessage } from "../../../helpers/utility.js";
import { getLedger, deleteLedger } from "../../../redux/slices/LedgerSlice.js";
import Swal from "sweetalert2";



const LedgerIndex = () => {
    const dispatch = useDispatch();
    const pageName = "Ledger";

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalPage, setTotalPage] = useState(0);

    const PARAMS = {
        skip: 0,
        take: rowsPerPage,
        searchStr: "",
    };

    const [data, setData] = useState([]);
    const [editData, setEditData] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [params, setParams] = useState(PARAMS);
    const [isEdit, setIsEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(()=> {
        getLedgerList();
    }, [params]);

    const getLedgerList = async() => {
        setIsLoading(true);
        setModalVisible(false);
        
        try {
            const { payload } = await dispatch(getLedger({ inputData: params }));
            setData(payload?.data);
            setTotalPage(Math.ceil(payload?.count/rowsPerPage)); 
        } catch (err) {
            toastMessage("error", "Failed to fetch data");
        } finally {
            setIsLoading(false); // Stop loader
        }
    };

    const openModal = () => {
        setModalVisible(true);
        setIsEdit(false);
    };

    const closeModal = () => {
        setModalVisible(false);
        setIsEdit(false);
    };

    const openEditModal = (item) => {
        setModalVisible(true);
        setIsEdit(true);
        setEditData(item);
    };

    const handleDelete = async(item) => {
        const updatedFormData = {
            ledger_Id: item.ledger_Id,
            type: "delete",
        };
        const { payload } = await dispatch(deleteLedger({ inputData: updatedFormData }));
        if (payload?.status === "error") {
            toastMessage("error", payload.msg || "An error occurred while saving.");
        } else {
            Swal.fire("Deleted!", "Your file has been deleted.", "success");
            getLedgerList();
        }
    };

    // const handleSort = (key) => {
    //     setParams((prev) => ({
    //         ...prev,
    //         sorting: prev.sorting_key === key && prev.sorting === "asc" ? "desc" : "asc",
    //         sorting_key: key,
    //     }));
    // };

    const handleSort = (key) => {
        setCurrentPage(1);
        
        setParams((prev) => ({
            ...prev,
            skip: 0,
            sorting_key: key,
            sorting: prev.sorting_key === key && prev.sorting === "asc" ? "desc" : "asc",
        }));
    };

    const handleRowsPerPageChange = (rows) => {
        setRowsPerPage(rows);
        setCurrentPage(1);
        
        setParams((prev) => ({
          ...prev,
          take: rows,
          skip: 0,
        }));
    };

    const setPage = (pagenum) => {
        setCurrentPage(pagenum);
        setParams((prev) => ({
            ...prev,
            skip: (pagenum - 1) * prev.take,
        }));
    };

    const columns = [
        { label: "#", accessor: "index", sortable: false },
        { label: "Name", accessor: "ledger_Name", sortable: true },
        { label: "Group", accessor: "group_Name", sortable: true },
        { label: "Op Balance", accessor: "ledger_Opening_Balance", sortable: true },
        { label: "Type", accessor: "ledger_type", sortable: true },
    ];



    return(
        <>
            <ToastContainer/>
            <PageWrapper 
                pageName={pageName}
                headerBtnTitle="+ Ledger"
                onHeaderButtonClick={() => openModal()}
                showAddBtn={true}
            >
                <DataTable
                    pageName={pageName}
                    data={data}
                    columns={columns}
                    onEdit={openEditModal}
                    onDelete={handleDelete}
                    deleteEnabled
                    onSorting={handleSort}
                    sortingState={{ key: params.sorting_key, order: params.sorting }}
                    currentPage={currentPage}
                    totalPages={totalPage}
                    rowsPerPage={rowsPerPage}
                    updateRowsPerPage={handleRowsPerPageChange}
                    onPageChange={setPage}
                    loader={isLoading}
                />
            </PageWrapper>

            <ModalWrapper
                visible = {modalVisible}
                onClose={() => closeModal()}
                modalTitle={isEdit ? "Edit " + pageName : "Add " + pageName}
                // modalSize={'lg'}
            >
                <LedgerAddEdit
                    reloadList={getLedgerList}
                    mode={isEdit}
                    data={editData}
                    closeModal={closeModal}
                />
            </ModalWrapper>
        </>
    );
};

export default LedgerIndex;